export const removeFormFieldStyles = {
	remover: {
		pointerEvents: 'auto',
		color: 'text.secondary',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		margin: 'auto',
		padding: 'auto',

		'&:hover': {
			color: 'text.primary',
			backgroundColor: 'var(--mui-palette-action-hover)'
		}
	},

	button: {
		fontWeight: 700
	},

	labelled: {
		textTransform: 'uppercase',
		fontWeight: 700,
		gap: 0.5,
		color: 'text.secondary',

		'&:hover': {
			color: 'text.primary',
			backgroundColor: 'transparent'
		}
	},

	icon: {
		width: '15px',
		height: '15px'
	}
};
